import { useState } from 'preact/hooks';

let cached: Index | undefined;

export const IDX_NAME = 0;
export const IDX_NAMESPACE = 1;
export const IDX_PACKAGE = 2;
export const IDX_TARGET = 3;

export const IDX_FULLNAME = 4;

export const IDX_KEY = 5;

export type Entry = [string, string, string, string, string, number];

export type Index = {
  entries: Entry[],
  packages: string[],
};

function importIndex(fetched: Entry[]): Index {
  let i = 0;
  const packages = new Set<string>();
  fetched.forEach((entry) => {
    packages.add(entry[IDX_PACKAGE]);

    entry[IDX_FULLNAME] = entry[IDX_NAMESPACE] + '.' + entry[IDX_NAME];
    entry[IDX_KEY] = i;
    i++;
  });

  return {
    entries: fetched,
    packages: Array.from(packages).sort(),
  };
}

async function fetchData() {
  if (cached) {
    // do not init twice
    return cached;
  }

  return fetch('data/index.json').then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error('error loading index: ' + res.status);
    }
  }).then((fetched: Entry[]) => {
    cached = importIndex(fetched);
    return cached;
  });
}

export function useData() {
  const [searchIndex, setData] = useState<Index>();
  async function load () {
    setData(await fetchData());
  }
  return { searchIndex, load };
}
